/**
 * Utilitário para obter URLs de bandeiras de seleções
 * Usa a API flagcdn.com para imagens de bandeiras reais
 */

const CODIGOS_ISO = {
  RSA: "za",  // África do Sul
  GER: "de",  // Alemanha
  KSA: "sa",  // Arábia Saudita
  ALG: "dz",  // Argélia
  ARG: "ar",  // Argentina
  AUS: "au",  // Austrália
  AUT: "at",  // Áustria
  BEL: "be",  // Bélgica
  BIH: "ba",  // Bósnia
  BRA: "br",  // Brasil
  CPV: "cv",  // Cabo Verde
  CAN: "ca",  // Canadá
  COL: "co",  // Colômbia
  KOR: "kr",  // Coreia do Sul
  CIV: "ci",  // Costa do Marfim
  CRO: "hr",  // Croácia
  CUW: "cw",  // Curaçao
  EGY: "eg",  // Egito
  ECU: "ec",  // Equador
  SCO: "gb-sct",  // Escócia
  ESP: "es",  // Espanha
  USA: "us",  // Estados Unidos
  FRA: "fr",  // França
  GHA: "gh",  // Gana
  HAI: "ht",  // Haiti
  ENG: "gb-eng",  // Inglaterra
  IRN: "ir",  // Irã
  IRQ: "iq",  // Iraque
  JPN: "jp",  // Japão
  JOR: "jo",  // Jordânia
  MAR: "ma",  // Marrocos
  MEX: "mx",  // México
  NOR: "no",  // Noruega
  NZL: "nz",  // Nova Zelândia
  NED: "nl",  // Holanda
  PAN: "pa",  // Panamá
  PAR: "py",  // Paraguai
  POR: "pt",  // Portugal
  QAT: "qa",  // Catar
  COD: "cd",  // República do Congo
  CZE: "cz",  // República Tcheca
  SEN: "sn",  // Senegal
  SWE: "se",  // Suécia
  SUI: "ch",  // Suíça
  TUN: "tn",  // Tunísia
  TUR: "tr",  // Turquia
  URU: "uy",  // Uruguai
  UZB: "uz"   // Uzbequistão
};

/**
 * Retorna a URL da imagem da bandeira para uma sigla FIFA
 * @param {string} sigla - Sigla oficial FIFA (ex: BRA, ARG, GER)
 * @param {number} width - Largura da imagem (20, 40, 80, 160)
 * @returns {string|null} URL da bandeira ou null se não encontrada
 */
export function getBandeiraUrl(sigla, width = 40) {
  const codigo = CODIGOS_ISO[sigla];
  if (!codigo) {
    console.warn(`Código ISO não encontrado para sigla FIFA: "${sigla}"`);
    return null;
  }
  
  return `https://flagcdn.com/w${width}/${codigo}.png`;
}

/**
 * Componente React para renderizar bandeira
 * @param {object} props
 * @param {string} props.sigla - Sigla oficial FIFA
 * @param {number} props.width - Largura da imagem
 * @param {string} props.className - Classes CSS adicionais
 * @returns {JSX.Element}
 */
export function Bandeira({ sigla, width = 40, className = "" }) {
  const url = getBandeiraUrl(sigla, width);
  
  if (!url) {
    return (
      <span className={`bandeira-sigla ${className}`}>
        {sigla}
      </span>
    );
  }
  
  return (
    <img 
      src={url} 
      alt={`Bandeira ${sigla}`}
      className={`bandeira-img ${className}`}
      onError={(e) => {
        e.target.style.display = 'none';
        const siglaSpan = document.createElement('span');
        siglaSpan.className = 'bandeira-sigla';
        siglaSpan.textContent = sigla;
        e.target.parentNode.appendChild(siglaSpan);
      }}
    />
  );
}

export default { getBandeiraUrl, Bandeira };
